import { DensityLarge, DensityMedium, DensitySmall } from '@mui/icons-material';
import { IconButton, Tooltip, SvgIcon } from '@mui/material';
import { GridDensity } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

import { GridDensityType } from '../../DataGridCustom.types';

const densityMap: { [key in GridDensity]: { Icon: typeof SvgIcon; next: GridDensity } } = {
  [GridDensityType.COMPACT]: {
    Icon: DensitySmall,
    next: GridDensityType.COMFORTABLE,
  },
  [GridDensityType.STANDARD]: {
    Icon: DensityMedium,
    next: GridDensityType.COMPACT,
  },
  [GridDensityType.COMFORTABLE]: {
    Icon: DensityLarge,
    next: GridDensityType.STANDARD,
  },
};

export interface DensityButtonProps {
  density?: GridDensity;
  onDensityChange?: (density: GridDensity) => void;
}

export const DensityButton = ({ density: densityProp, onDensityChange }: DensityButtonProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'DataGrid.densityButton' });
  const density = densityProp || GridDensityType.STANDARD;
  const { next } = densityMap[density];
  const { Icon } = densityMap[next];

  return (
    <Tooltip title={t(next)} arrow>
      <IconButton
        size="small"
        color="inherit"
        onClick={() => {
          if (onDensityChange) {
            onDensityChange(next);
          }
        }}
      >
        <Icon fontSize="small" color="inherit" />
      </IconButton>
    </Tooltip>
  );
};
